import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=5ae29264&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=ts"
export * from "./Landing.vue?vue&type=script&lang=ts"
import style0 from "./Landing.vue?vue&type=style&index=0&id=5ae29264&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae29264",
  null
  
)

export default component.exports